<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useReviewReportStore } from '@/store';

const { students } = storeToRefs(useReviewReportStore());

const total = computed(() => new Intl.NumberFormat().format(students.value.data.total || 0));

const active = computed(() => new Intl.NumberFormat().format(students.value.data.active || 0));

const inactive = computed(() => new Intl.NumberFormat().format(students.value.data.inactive || 0));
</script>

<template>
  <div class="p-3 surface-100 border-round-xl">
    <div class="flex align-items-center>">
      <h3 class="flex-1 text-base text-color-secondary mb-2">Students</h3>
      <Icon
        v-tooltip.left="
          'Total: all students with scheduled events. Active: students with scheduled events and active services. Inactive: students with scheduled events but no active services.'
        "
        name="info"
        class="text-gray-400 text-base cursor-pointer"
      />
    </div>
    <div class="flex gap-2">
      <div class="p-2 border-round bg-white">
        <div class="text-color-gray text-sm">Total</div>
        <Skeleton v-if="students.loading" height="1rem" class="mt-1" />
        <div v-else class="text-color-green text-lg font-bold" v-text="total" />
      </div>
      <div class="p-2 border-round bg-white">
        <div class="text-color-gray text-sm">Active</div>
        <Skeleton v-if="students.loading" height="1rem" class="mt-1" />
        <div v-else class="text-color-blue text-lg font-bold" v-text="active" />
      </div>
      <div class="p-2 border-round bg-white">
        <div class="text-color-gray text-sm">Inactive</div>
        <Skeleton v-if="students.loading" height="1rem" class="mt-1" />
        <div v-else class="text-color-orange text-lg font-bold" v-text="inactive" />
      </div>
    </div>
  </div>
</template>
